import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";

const AdminsView = (props) => {
    const {setDate} = props
    let navigate = useNavigate();
        return(
            <div className="container">
                <Navbar />
                <div>
                    <button 
                        className="btn btn-info btn-lg" 
                        onClick={()=>{
                        navigate('/MenageUsers');
                    }}>Zarządzaj pracownikami</button>
                </div>
                <div>
                    <button 
                        className="btn btn-info btn-lg" 
                        onClick={()=>{
                            setDate(new Date())
                        navigate('/MainCalendar');
                    }}>Główny kalendarz</button>
                </div>
                <div>
                    <button 
                        className="btn btn-info btn-lg" 
                        onClick={()=>{
                        navigate('/ManageServices');
                    }}>Zarządzaj usługami</button>
                </div>
                <div>
                    <button
                        className="btn btn-info btn-lg"  
                        onClick={()=>{
                        navigate('/EventsHistory');
                    }}>Historia wizyt</button>
                </div>
                <div>
                    <button  
                        className="btn btn-info btn-lg"  
                        onClick={()=>{
                        navigate('/Stations');
                    }}>Stanowiska</button>
                </div>
            </div>
        );
}

export default AdminsView;
